(function () {
  const toggles = document.querySelectorAll("[data-js-slot-demo-toggle]");

  for (const toggle of toggles) {
    const dialog = document.getElementById(toggle.dataset.target);
    const iframe = dialog.querySelector("[data-js-slot-demo-frame]");
    const close = dialog.querySelector("[data-js-slot-demo-close]");

    if (!dialog || !iframe) continue;

    toggle.addEventListener("click", () => {
      iframe.src = iframe.dataset.src;
      iframe.hidden = false;
      dialog.showModal();
    });

    close.addEventListener("click", () => dialog.close());

    dialog.addEventListener("close", () => {
      iframe.removeAttribute("src");
      iframe.hidden = true;
    });
  }
})();
